import { useState } from "react";
import Cursor from "./Cursor";
import Nav from "./Nav";
import Hero from "./Hero";
import StoicStrip from "./StoicStrip";
import About from "./About";
import Experience from "./Experience";
import ProjectsSection from "./ProjectsSection";
import Skills from "./Skills";
import Blog from "./Blog";
import Contact from "./Contact";
import Footer from "./Footer";
import Divider from "./Divider";
import ArticleMarcus from "./ArticleMarcus";

const ARTICLES = { marcus: ArticleMarcus };

const App = () => {
  const [article, setArticle] = useState(null);

  const openArticle = (key) => {
    setArticle(key);
    window.scrollTo(0, 0);
  };
  const closeArticle = () => {
    setArticle(null);
    window.scrollTo(0, 0);
  };

  if (article) {
    const ArticleComponent = ARTICLES[article];
    return (
      <>
        <Cursor />
        <Nav />
        <ArticleComponent onBack={closeArticle} />
        <Footer />
      </>
    );
  }

  return (
    <>
      <Cursor />
      <Nav />
      <Hero />
      <StoicStrip />
      <About />
      <Divider />
      {/* <Experience /> */}
      <Divider />
      <ProjectsSection />
      <Divider />
      <Skills />
      <Divider />
      <Blog onOpenArticle={openArticle} />
      <Divider />
      <Contact />
      <Footer />
    </>
  );
};

export default App;
